module.exports = __webpack_public_path__ + "img/mobile_map_mataro.e30aacc0.svg";